/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Custom serializer that adds permission fields.
 * @export
 * @interface Permissions
 */
export interface Permissions {
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    mapView?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    mapEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    epasepView?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    epasepEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    analyticsView?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    analyticsEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    emissionEventView?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    emissionEventEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    emissionEventApprove?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    emissionEventArchive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    emissionView?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    emissionEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    emissionExport?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    infrastructureView?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    infrastructureEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    infrastructureBuilderView?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    infrastructureBuilderEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    dataUploadsView?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    dataUploadsEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    dataDownloadView?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    dataDownloadEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    notificationsView?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    notificationsEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    mobileAppView?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    mobileAppEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    externalApiView?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    externalApiEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    unmatchedEmissionView?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permissions
     */
    unmatchedEmissionEdit?: boolean;
}

/**
 * Check if a given object implements the Permissions interface.
 */
export function instanceOfPermissions(value: object): value is Permissions {
    return true;
}

export function PermissionsFromJSON(json: any): Permissions {
    return PermissionsFromJSONTyped(json, false);
}

export function PermissionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Permissions {
    if (json == null) {
        return json;
    }
    return {
        
        'mapView': json['map_view'] == null ? undefined : json['map_view'],
        'mapEdit': json['map_edit'] == null ? undefined : json['map_edit'],
        'epasepView': json['epasep_view'] == null ? undefined : json['epasep_view'],
        'epasepEdit': json['epasep_edit'] == null ? undefined : json['epasep_edit'],
        'analyticsView': json['analytics_view'] == null ? undefined : json['analytics_view'],
        'analyticsEdit': json['analytics_edit'] == null ? undefined : json['analytics_edit'],
        'emissionEventView': json['emission_event_view'] == null ? undefined : json['emission_event_view'],
        'emissionEventEdit': json['emission_event_edit'] == null ? undefined : json['emission_event_edit'],
        'emissionEventApprove': json['emission_event_approve'] == null ? undefined : json['emission_event_approve'],
        'emissionEventArchive': json['emission_event_archive'] == null ? undefined : json['emission_event_archive'],
        'emissionView': json['emission_view'] == null ? undefined : json['emission_view'],
        'emissionEdit': json['emission_edit'] == null ? undefined : json['emission_edit'],
        'emissionExport': json['emission_export'] == null ? undefined : json['emission_export'],
        'infrastructureView': json['infrastructure_view'] == null ? undefined : json['infrastructure_view'],
        'infrastructureEdit': json['infrastructure_edit'] == null ? undefined : json['infrastructure_edit'],
        'infrastructureBuilderView': json['infrastructure_builder_view'] == null ? undefined : json['infrastructure_builder_view'],
        'infrastructureBuilderEdit': json['infrastructure_builder_edit'] == null ? undefined : json['infrastructure_builder_edit'],
        'dataUploadsView': json['data_uploads_view'] == null ? undefined : json['data_uploads_view'],
        'dataUploadsEdit': json['data_uploads_edit'] == null ? undefined : json['data_uploads_edit'],
        'dataDownloadView': json['data_download_view'] == null ? undefined : json['data_download_view'],
        'dataDownloadEdit': json['data_download_edit'] == null ? undefined : json['data_download_edit'],
        'notificationsView': json['notifications_view'] == null ? undefined : json['notifications_view'],
        'notificationsEdit': json['notifications_edit'] == null ? undefined : json['notifications_edit'],
        'mobileAppView': json['mobile_app_view'] == null ? undefined : json['mobile_app_view'],
        'mobileAppEdit': json['mobile_app_edit'] == null ? undefined : json['mobile_app_edit'],
        'externalApiView': json['external_api_view'] == null ? undefined : json['external_api_view'],
        'externalApiEdit': json['external_api_edit'] == null ? undefined : json['external_api_edit'],
        'unmatchedEmissionView': json['unmatched_emission_view'] == null ? undefined : json['unmatched_emission_view'],
        'unmatchedEmissionEdit': json['unmatched_emission_edit'] == null ? undefined : json['unmatched_emission_edit'],
    };
}

export function PermissionsToJSON(json: any): Permissions {
    return PermissionsToJSONTyped(json, false);
}

export function PermissionsToJSONTyped(value?: Permissions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'map_view': value['mapView'],
        'map_edit': value['mapEdit'],
        'epasep_view': value['epasepView'],
        'epasep_edit': value['epasepEdit'],
        'analytics_view': value['analyticsView'],
        'analytics_edit': value['analyticsEdit'],
        'emission_event_view': value['emissionEventView'],
        'emission_event_edit': value['emissionEventEdit'],
        'emission_event_approve': value['emissionEventApprove'],
        'emission_event_archive': value['emissionEventArchive'],
        'emission_view': value['emissionView'],
        'emission_edit': value['emissionEdit'],
        'emission_export': value['emissionExport'],
        'infrastructure_view': value['infrastructureView'],
        'infrastructure_edit': value['infrastructureEdit'],
        'infrastructure_builder_view': value['infrastructureBuilderView'],
        'infrastructure_builder_edit': value['infrastructureBuilderEdit'],
        'data_uploads_view': value['dataUploadsView'],
        'data_uploads_edit': value['dataUploadsEdit'],
        'data_download_view': value['dataDownloadView'],
        'data_download_edit': value['dataDownloadEdit'],
        'notifications_view': value['notificationsView'],
        'notifications_edit': value['notificationsEdit'],
        'mobile_app_view': value['mobileAppView'],
        'mobile_app_edit': value['mobileAppEdit'],
        'external_api_view': value['externalApiView'],
        'external_api_edit': value['externalApiEdit'],
        'unmatched_emission_view': value['unmatchedEmissionView'],
        'unmatched_emission_edit': value['unmatchedEmissionEdit'],
    };
}

